import React from 'react';
import QRCode from 'react-qr-code';
import '@tabler/core/dist/css/tabler.min.css';

function WhatsAppQRModal({ qrCode, onClose }) {
  if (!qrCode) return null;

  return (
    <div
      className="modal modal-blur fade show"
      style={{
        display: 'block',
        backgroundColor: 'rgba(0,0,0,0.8)'
      }}
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Conectar WhatsApp</h5>
          </div>
          <div className="modal-body text-center py-5">
            <div className="mb-3">
              <div
                style={{
                  padding: '20px',
                  background: 'white',
                  display: 'inline-block',
                  borderRadius: '8px'
                }}
              >
                <QRCode value={qrCode} size={256} />
              </div>
            </div>
            <h3 className="mb-3">Escanea el código QR</h3>
            <ol className="text-start" style={{maxWidth: '400px', margin: '0 auto'}}>
              <li className="mb-2">Abre <strong>WhatsApp</strong> en tu teléfono</li>
              <li className="mb-2">Ve a <strong>Configuración</strong> → <strong>Dispositivos vinculados</strong></li>
              <li className="mb-2">Toca en <strong>Vincular un dispositivo</strong></li>
              <li className="mb-2">Apunta tu teléfono a esta pantalla para escanear el código</li>
            </ol>
          </div>
          <div className="modal-footer">
            <small className="text-muted">
              El código se actualizará automáticamente si expira
            </small>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhatsAppQRModal;
